import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { orderedQuantity: Number };
  static targets = ['quantity', 'form'];

  disconnect() {
    this.removeProceedHandler();
  }

  confirm(event) {
    const qty = parseInt(this.quantityTarget.value);
    const orderedQty = this.orderedQuantityValue;

    if (qty !== orderedQty && qty < 0) {
      event.preventDefault();

      const modal = document.getElementById('global-modal');
      this.removeProceedHandler();

      this.proceedHandler = () => {
        this.removeProceedHandler();
        $(modal).modal('hide');
        this.formTarget.submit();
      };

      modal
        .querySelector('.btn-primary')
        .addEventListener('click', this.proceedHandler);

      showModal({
        title: 'Action Required',
        body: `The order quantity (${orderedQty}) differs from the allocated negative quantity (${qty}). Do you want to continue?`,
        submitText: 'Confirm',
      });
    }
  }

  removeProceedHandler() {
    if (!this.proceedHandler) return;

    document
      .getElementById('global-modal')
      ?.querySelector('.btn-primary')
      ?.removeEventListener('click', this.proceedHandler);

    this.proceedHandler = null;
  }
}
